export default "__VITE_ASSET__GVrW3hPX__"